"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "m20.716 22.364-10.95-10.8a.77.77 0 0 1-.28-.66.49.49 0 0 0-.11-.33l-2.18-2.3c-.11-.12-.21-.15-.33 0a.89.89 0 0 1-1.27-.17 1 1 0 0 0-1.4.17 1 1 0 0 1-.14.17 1.24 1.24 0 0 0-.4 1.17.51.51 0 0 1-.17.43c-.06.063-.122.142-.19.226-.364.455-.86 1.074-1.62.424a12.168 12.168 0 0 0-.643-.53c-.101-.077-.193-.147-.648-.54C-.329 9.006.11 8.51.44 8.137c.081-.092.156-.176.205-.253a1.1 1.1 0 0 1 1-.45.44.44 0 0 0 .44-.16 1.62 1.62 0 0 1 .19-.18 1.23 1.23 0 0 0 .54-1.08.54.54 0 0 1 .18-.34l3.21-3.62a.54.54 0 0 1 .21-.16 5.45 5.45 0 0 1 5.79.47l.07.044c.125.076.269.164.21.356a.47.47 0 0 1-.47.32h-.94a4.86 4.86 0 0 0-2.4.46 5.891 5.891 0 0 0-.54.32.48.48 0 0 0-.21.62c.046.13.107.254.18.37a1 1 0 0 0 .14.17 1 1 0 0 1 .29 1.25.5.5 0 0 0 .14.64c.401.413.795.83 1.183 1.241.241.256.48.51.718.759a.43.43 0 0 0 .43.13.62.62 0 0 1 .53.22l11 10.84c1.13 1.17-.54 3.52-1.82 2.26Zm-6.447-12.09c.409-.504.814-1.005 1.207-1.52a2 2 0 0 0 .34-1.48v-2a2.55 2.55 0 0 1 .75-1.62 5.92 5.92 0 0 1 3-1.77 1.31 1.31 0 0 1 .65 0c.25.07.31.28.19.52-.37.76-.74 1.52-1.12 2.28a1.22 1.22 0 0 0 .35 1.68 1.48 1.48 0 0 0 1.64.25.61.61 0 0 0 .27-.28c.234-.533.458-1.07.682-1.605.158-.38.316-.758.478-1.135.076-.174.177-.335.3-.48a.33.33 0 0 1 .56.15 11.9 11.9 0 0 1 .32 4.82 2.5 2.5 0 0 1-2.47 2.35c-.404.032-.805.047-1.206.062-.334.013-.668.025-1.004.048a7.009 7.009 0 0 0-.78.12 1.56 1.56 0 0 0-1 .62c-.27.36-.74.92-1.4 1.69l-2.21-2.15.18-.21c.09-.114.182-.226.273-.34Zm-.954 5.72a725.132 725.132 0 0 1-4.18 5.28l-.02.06c-.37.48-1.71 2.19-3.28.94-1.564-1.246-.279-2.65.156-3.125l.004-.005v-.06l4.92-5.4 2.4 2.31Zm-6.18 5.63h-.04.04Zm-.454-.126a.81.81 0 0 0 .415.126.8.8 0 0 0 .83-.82.81.81 0 1 0-1.245.694Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};